import Customer from "./Customers";
export default Customer;
